import React, { Component } from 'react';
import fukakusa from '../assets/fukakusa.png';
import danai from '../assets/danai.png';
import kanin from '../assets/kanin.png';
import natthaphat from '../assets/natthaphat.png';
import worapot from '../assets/worapot.png';
import torrit from '../assets/torrit.png';
import logo2 from '../assets/logo2.png';
import background from '../assets/background.png';

class Instructors extends Component {
  render() {
    const pageStyle = {
      // 70% white overlay on top of the background image -> image appears ~30% visible
      backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${background})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
    };

    const contentStyle = {
      maxWidth: 900,
      margin: '0 auto',
      padding: '32px 16px 48px',
      color: '#111',
      lineHeight: 1.6,
    };

    const sectionStyle = {
      margin: '32px 0',
      paddingBottom: 16,
      borderBottom: '1px solid rgba(0,0,0,0.08)',
    };

    const photoStyle = {
      width: '260px',
      maxWidth: '100%',
      display: 'block',
      margin: '0 auto 12px',
      borderRadius: '12px',
      boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
    };

    const poweredByStyle = {
      textAlign: 'center',
      marginTop: 40,
    };

    return (
      <div className="Instructors" style={pageStyle}>
        <div style={contentStyle}>
          <h1 style={{ textAlign: 'center', marginBottom: 24 }}>
            Thai-Aikikai&apos;s Instructors
          </h1>

          {/* 1. Fukakusa Shihan */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={fukakusa} alt="Motohiro Fukakusa Shihan" />
            <h2 style={{ textAlign: 'center' }}>
              1. MOTOHIRO FUKAKUSA SHIHAN — 8th Dan, Aikikai, Japan (Chief Instructor & President)
            </h2>
            <p>
              Fukakusa Shihan is honoured as the Father of Aikido in Thailand. He has been in
              Thailand since 1964 and was one of the first faculty teaching and demonstrating
              Aikido throughout Thailand, which was first introduced in 1961.
            </p>
            <p>
              In 1975, Fukakusa Shihan established the Aikido Association of Thailand and has
              held the office of President since then. All of his students have rights to be
              members under the Aikido World Headquarters (Tokyo, Japan) and the International
              Aikido Federation (IAF).
            </p>
            <p>
              Fukakusa Shihan established “Renbukan Dojo” on Nov 26, 1998 as the practicing
              center for all members. He is also appointed by the Aikido World Headquarters to
              be a caretaker controlling teaching techniques throughout Southeast Asia. Moreover,
              he frequently travels abroad to conduct seminars and is invited to instruct airline
              crews, law enforcement, and the military of Thailand and various countries.
            </p>
          </section>

          {/* 2. Gen. Danai */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={danai} alt="Gen. Danai Yuwaboon" />
            <h3 style={{ textAlign: 'center' }}>
              2. GEN. DANAI YUWABOON — 6th Dan, Aikikai, Japan (Deputy Chief Instructor & Deputy President)
            </h3>
          </section>

          {/* 3. Mr. Kanin */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={kanin} alt="Kanin Ampaipan" />
            <h3 style={{ textAlign: 'center' }}>
              3. MR. KANIN AMPAIPAN — 5th Dan, Aikikai, Japan (Instructor)
            </h3>
          </section>

          {/* 4. Mr. Natthaphat */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={natthaphat} alt="Natthaphat Ingsakulsomboon" />
            <h3 style={{ textAlign: 'center' }}>
              4. MR. NATTHAPHAT INGSAKULSOMBOON — 5th Dan, Aikikai, Japan (Instructor)
            </h3>
          </section>

          {/* 5. Mr. Worapot */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={worapot} alt="Worapot Benjanart" />
            <h3 style={{ textAlign: 'center' }}>
              5. MR. WORAPOT BENJANART — 5th Dan, Aikikai, Japan (Instructor)
            </h3>
          </section>

          {/* 6. Mr. Torrit */}
          <section className="instructor" style={sectionStyle}>
            <img style={photoStyle} src={torrit} alt="Worapot Benjanart" />
            <h3 style={{ textAlign: 'center' }}>
              6. MR. TORRIT BOONYAKIAT — 4th Dan, Aikikai, Japan (Instructor Goshin-Jitsu)
            </h3>
          </section>



          <footer className="powered-by" style={poweredByStyle}>
            <div>Powered by</div>
            <img
              className="logo2"
              src={logo2}
              alt="New Wave Consulting Group"
              style={{ height: 50, display: 'block', margin: '8px auto' }}
            />
            <div>New Wave Consulting Group</div>
          </footer>
        </div>
      </div>
    );
  }
}

export default Instructors;
